var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_6102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.5C7.99187 1.5 1.5 7.99187 1.5 16C1.5 24.0081 7.99187 30.5 16 30.5C24.0081 30.5 30.5 24.0081 30.5 16C30.5 7.99187 24.0081 1.5 16 1.5ZM0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.555 21.6198L18.3354 17.3995C18.9844 16.5474 19.3496 15.4518 19.3496 14.2748C19.3496 11.3532 16.9963 9 14.0746 9C11.1529 9 8.79883 11.354 8.79883 14.2756C8.79883 17.1972 11.1521 19.5504 14.0738 19.5504C15.2509 19.5504 16.3054 19.1852 17.1986 18.5362L21.4191 22.7565C21.5812 22.9186 21.7843 23 21.9875 23C22.1906 23 22.393 22.9186 22.5558 22.7565C22.88 22.4317 22.88 21.9447 22.5551 21.6199L22.555 21.6198ZM14.0746 17.9276C12.0454 17.9276 10.4225 16.3047 10.4225 14.2756C10.4225 12.2465 12.0454 10.6236 14.0746 10.6236C16.1038 10.6236 17.7267 12.2465 17.7267 14.2756C17.7267 16.3039 16.103 17.9276 14.0746 17.9276Z",
    fill: "#ADB5BD",
    stroke: "#ADB5BD",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_6102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.b7242904c18b78ef63e83a9078ad928b.svg";
export { ForwardRef as ReactComponent };